import 'consumerweb-shim';
import React from 'react';
import { connect } from 'react-redux';

import LiveStream from '../../liveStream';

export class LiveStreamContainer extends React.Component {
  render() {
    return (
      <div>
        <LiveStream {...this.props} />
      </div>
    );
  }
}

export default connect(state => ({
  contributions: state.server.contributions,
  coBrand: state.server.coBrand,
}))(LiveStreamContainer);
